import { ComparePlansDialog } from "@/dialogs/compare-plans-dialog";
import { track } from "@/features/analytics";
import Button from "@components/ui/button";
import { useAppDispatch } from "@store";
import { closeDialog, openDialog } from "@store/dialogs";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const PlanHasBeenCancelled = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();

  useEffect(() => {
    const excludeRegex =
      /^\/pages\/(profile\/(plans|users|subscription|invoices)|help)/;
    if (excludeRegex.test(location.pathname)) {
      dispatch(closeDialog("plan-has-been-cancelled"));
    }
  }, [location.pathname, dispatch]);

  const onSubscribeNow = () => {
    dispatch(
      openDialog({
        id: ComparePlansDialog.id,
        content: ComparePlansDialog,
      }),
    );
  };

  const onContactUs = () => {
    track("click contact us");
    window.open("https://help.storydoc.com", "_blank");
    dispatch(closeDialog("plan-has-been-cancelled"));
  };

  return (
    <div className="tw-grid tw-w-[616px] tw-place-items-center tw-rounded-lg tw-bg-white tw-py-14 tw-shadow-main">
      <img
        src="/assets/images/plan-has-been-cancelled.svg"
        width="184"
        height="184"
        alt=""
        className="tw-mb-10 tw-size-[184px]"
      />
      <h2 className="tw-mb-2 tw-mt-0 tw-text-center tw-font-sans tw-text-2xl tw-font-bold">
        Your plan has been cancelled 😔
      </h2>
      <p className="tw-mx-auto tw-mb-10 tw-mt-0 tw-max-w-[434px] tw-text-center tw-font-sans tw-text-base tw-font-normal">
        Keep creating amazing presentations by re-activating your subscription
      </p>
      <div className="tw-flex tw-items-center tw-justify-center">
        <Button className="tw-mr-4" variant="pro" onClick={onSubscribeNow}>
          <Button.Icon icon="ri-vip-crown-fill" />
          Subscribe now
        </Button>
        <Button variant="secondary" onClick={onContactUs}>
          <Button.Icon icon="ri-mail-fill" />
          Contact us
        </Button>
      </div>
    </div>
  );
};

export default PlanHasBeenCancelled;
